(function(){
var root=document.getElementById('pxd');
if(!root||root.getAttribute('data-ready')){return;}
root.setAttribute('data-ready','1');
function g(id){return document.getElementById(id);}
function num(a,d){var v=parseFloat(root.getAttribute(a));return isNaN(v)?d:v;}
var P={p18:num('data-p18',205),p24:num('data-p24',259),p32:num('data-p32',347),small:num('data-small',6),big:num('data-big',12),min:num('data-min',129),hang:num('data-hang',0),table:num('data-table',0),logo:num('data-logo',0),rgb:num('data-rgbchange',0),flow:num('data-dynamic',0),letter:num('data-letter',0),rect:num('data-rect',0),circle:num('data-circle',0),icon:num('data-icon',0),dimmer:num('data-dimmer',0),quote:num('data-quote',499)};
var AP=String.fromCharCode(39);
var NL=String.fromCharCode(10);
var FONTS=[['Tilt Neon','Tilt Neon',400,'sans-serif'],['Neon Tube','Neonderthaw',400,'cursive'],['Sacramento','Sacramento',400,'cursive'],['Lobster','Lobster',400,'cursive'],['Pacifico','Pacifico',400,'cursive'],['Yellowtail','Yellowtail',400,'cursive'],['Dancing','Dancing Script',700,'cursive'],['Satisfy','Satisfy',400,'cursive'],['Playball','Playball',400,'cursive'],['Parisienne','Parisienne',400,'cursive'],['Cookie','Cookie',400,'cursive'],['Mr Dafoe','Mr Dafoe',400,'cursive'],['Marck Script','Marck Script',400,'cursive'],['Damion','Damion',400,'cursive'],['Kaushan Script','Kaushan Script',400,'cursive'],['Marker','Permanent Marker',400,'cursive'],['Great Vibes','Great Vibes',400,'cursive'],['Bebas','Bebas Neue',400,'sans-serif'],['Poppins','Poppins',500,'sans-serif'],['Fredoka','Fredoka',500,'sans-serif'],['Righteous','Righteous',400,'sans-serif'],['Audiowide','Audiowide',400,'sans-serif'],['Oswald','Oswald',500,'sans-serif'],['Monoton','Monoton',400,'sans-serif']];
var COLORS=[['Warm White','#FFC98A'],['Pink','#FF2D95'],['Blue','#3B82F6'],['Cyan','#22D3EE'],['Purple','#A855F7'],['Red','#EF4444'],['Orange','#FB923C'],['Green','#22C55E']];
var CFG={neon:{name:'Neon Sign',sizes:[18,24,32],min:10,max:48,wall:60,def:24},logo:{name:'Logo Neon',sizes:[18,24,32],min:10,max:48,wall:60,def:24},metal:{name:'Metal Sign',sizes:[24,36,48],min:12,max:144,wall:144,def:36},acrylic:{name:'Acrylic Sign',sizes:[18,24,36],min:10,max:144,wall:144,def:24},business:{name:'Business Sign',sizes:[36,60,96],min:24,max:144,wall:144,def:60}};
var QUOTE={business:1,metal:1,acrylic:1};
var MOUNTS={wall:['Wall mounted',0],hang:['Hanging',P.hang],table:['Table stand',P.table]};
var ICONS=[['Heart','<path d="M12 21s-7.5-4.8-9.7-9.6C.6 7.8 2.6 4 6.4 4c2.2 0 3.7 1.3 5.6 3.2C13.900 5.300 15.400 4 17.600 4c3.800 0 5.800 3.800 4.100 7.400C19.500 16.200 12 21 12 21z"/>'],['Star','<path d="M12 2.800l2.900 6 6.600.9-4.800 4.600 1.200 6.500L12 17.600 6.100 20.800l1.200-6.500L2.500 9.700l6.600-.9z"/>'],['Crown','<path d="M3 19h18M3 17L2 7l5 4 5-7 5 7 5-4-1 10z"/>'],['Bolt','<path d="M13.500 2L5 13.500h6L9.500 22 19 10h-6.500z"/>'],['Flame','<path d="M12 2.500c.8 4.200 5.500 6 5.500 11a5.500 5.500 0 0 1-11 0c0-2.200 1-3.500 2.200-4.600.1 2 1 3 2.300 3.200C10.300 8.500 10.500 5.500 12 2.500z"/>'],['Moon','<path d="M20 14.500A8.500 8.500 0 1 1 9.500 4a7 7 0 0 0 10.500 10.500z"/>'],['Butterfly','<path d="M12 12C9.500 4 2.500 3.500 3.200 9.500 3.600 12.500 7.500 13.500 12 12zM12 12c2.500-8 9.500-8.500 8.800-2.500-.4 3-4.300 4-8.800 2.500zM12 12c-3.500.8-6.500 3-5.300 6.800.9 2.600 4.300 1.300 5.300-2.800zM12 12c3.500.8 6.500 3 5.300 6.800-.9 2.600-4.300 1.300-5.300-2.800zM12 8v10"/>'],['Music','<path d="M9 18V5.500l11-2V16M9 18a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM20 16a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/>'],
['Cloud','<path d="M6.500 18.500a4 4 0 0 1-.4-7.980 5.500 5.500 0 0 1 10.500-1.400A4.500 4.500 0 0 1 17.500 18.500z"/>'],
['Sun','<path d="M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8zM12 2v2.500M12 19.500V22M2 12h2.500M19.500 12H22M4.900 4.900l1.800 1.800M17.300 17.300l1.800 1.800M4.900 19.100l1.800-1.800M17.300 6.700l1.800-1.800"/>'],
['Sparkles','<path d="M14 3c.6 4 2.400 5.800 6.500 6.500-4.100.7-5.900 2.500-6.500 6.500-.6-4-2.400-5.800-6.500-6.500C11.600 8.800 13.400 7 14 3zM6 16c.3 1.800 1.100 2.700 3 3-1.900.3-2.700 1.200-3 3-.3-1.800-1.100-2.700-3-3 1.900-.3 2.700-1.200 3-3z"/>'],
['Diamond','<path d="M6 4h12l4 5-10 12L2 9zM2 9h20M9 4L7 9l5 12 5-12-2-5"/>'],
['Cocktail','<path d="M4 4h16l-8 9zM12 13v8M8 21h8M16 4l3-2"/>']];
var PLUGS=['US / Canada','UK','EU','Australia'];
var S={view:'board',fx:'',back:'shape',icon:'',iconPos:'left',dimmer:false,plug:'US / Canada',cat:'neon',text:'',font:'Tilt Neon',color:'#FF2D95',colorName:'Pink',size:24,mount:'wall',place:'Indoor',scene:'charcoal',sceneUser:false,on:true,logoUrl:'',logoName:'',photoUrl:''};
var E={stage:g('pxdStage'),wrap:g('pxdWrap'),halo:g('pxdHalo'),text:g('pxdText'),logo:g('pxdLogo'),meas:g('pxdMeas'),photo:g('pxdPhoto'),icon:g('pxdIcon')};
var FONT_PAGE_SIZE=8;
var fontPage=0;

function fontObj(n){for(var i=0;i<FONTS.length;i++){if(FONTS[i][0]===n){return FONTS[i];}}return FONTS[0];}
function stack(f){return AP+f[1]+AP+','+f[3];}
function tint(hex,t){var n=parseInt(hex.slice(1),16),r=(n>>16)&255,gg=(n>>8)&255,b=n&255;r=Math.round(r+(255-r)*t);gg=Math.round(gg+(255-gg)*t);b=Math.round(b+(255-b)*t);return 'rgb('+r+','+gg+','+b+')';}
function hexOk(h){return /^#[0-9a-fA-F]{6}$/.test(h);}
function priceFor(sz){
if(sz<=18){return Math.max(P.min,P.p18-(18-sz)*P.small);}
if(sz<=24){return P.p18+(P.p24-P.p18)*(sz-18)/6;}
if(sz<=32){return P.p24+(P.p32-P.p24)*(sz-24)/8;}
return P.p32+(sz-32)*P.big;
}
function dimmerOn(){return (S.dimmer||!!S.fx)&&!(QUOTE[S.cat]&&S.place==='Outdoor');}
function calc(){
var r={lines:[],total:0,quote:false,note:''};
if(QUOTE[S.cat]){r.quote=true;return r;}
var base=Math.round(priceFor(S.size));
r.lines.push(['Sign, '+sizeText(),base]);r.total+=base;
if(S.cat==='logo'&&P.logo){r.lines.push(['Logo set-up',P.logo]);r.total+=P.logo;}
if(S.fx==='rgb'&&P.rgb){r.lines.push(['RGB Color Changing',P.rgb]);r.total+=P.rgb;}
if(S.fx==='dynamic'&&P.flow){r.lines.push(['Dynamic Neon',P.flow]);r.total+=P.flow;}
var bkp=BK[bkType()];if(bkp[1]){r.lines.push(['Backboard: '+bkp[0].toLowerCase(),bkp[1]]);r.total+=bkp[1];}
if(S.icon&&S.cat!=='logo'&&P.icon){var ip=Math.max(10,Math.round(base*P.icon/100));r.lines.push(['Icon: '+S.icon,ip]);r.total+=ip;}
if(S.dimmer&&!S.fx&&dimmerOn()&&P.dimmer){r.lines.push(['Dimmer + remote',P.dimmer]);r.total+=P.dimmer;}
var m=MOUNTS[S.mount];
if(m[1]){r.lines.push([m[0],m[1]]);r.total+=m[1];}
if(S.size>32){r.note='Sizes over 32 in are confirmed in your free mockup.';}
return r;
}
function money(n){return '$'+n;}
var HT=0;
var NW=0,NH=0;
var BK={shape:['Cut to shape',0],letter:['Cut to letter',P.letter],rect:['Rectangle',P.rect],circle:['Circle',P.circle],plain:['Standard',0]};
function hasBoard(){return S.cat==='neon'||S.cat==='logo'||S.cat==='business';}
function bkType(){return S.cat==='logo'?'shape':((S.cat==='metal'||S.cat==='acrylic')?'plain':S.back);}
function fmt(n){return String(Math.round(n*10)/10);}
function sizeText(){return HT?S.size+' x '+HT+' in':S.size+' in wide';}

function rgba(hex,a){var n=parseInt(hex.slice(1),16);return 'rgba('+((n>>16)&255)+','+((n>>8)&255)+','+(n&255)+','+a+')';}
var fxT0=performance.now(),fxRaf=0,fxLast=0,fxLetters=[];
var REDUCE=!!(window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches);
function hsl2hex(h,sat,l){h=((h%360)+360)%360;sat/=100;l/=100;var a=sat*Math.min(l,1-l);function f(n){var k=(n+h/30)%12,c=l-a*Math.max(Math.min(k-3,9-k,1),-1),x=Math.round(255*c).toString(16);return x.length<2?'0'+x:x;}return '#'+f(0)+f(8)+f(4);}
function glowShadow(col){return '0 0 1px '+tint(col,0.9)+',0 0 .04em '+col+',0 0 .1em '+col+',0 0 .22em '+col+',0 0 .45em '+rgba(col,.8)+',0 0 .9em '+rgba(col,.45);}
function fxOn(){return S.on&&!!S.fx;}
function paintIcon(col){
var ic=E.icon;
if(!S.on){ic.style.color='#5b5b72';ic.style.filter='none';return;}
ic.style.color=tint(col,0.82);
ic.style.filter='drop-shadow(0 0 2px '+col+') drop-shadow(0 0 8px '+col+') drop-shadow(0 0 16px '+rgba(col,.6)+')';
}
function paintHalo(c1,c2){E.halo.style.background='radial-gradient(closest-side,'+rgba(c1,.32)+','+rgba(c2,.12)+' 55%,transparent)';}
function fxApply(t){
if(!fxOn()){return;}
var hs=t*60,dyn=S.fx==='dynamic',uni=hsl2hex(dyn?-hs:t*45,100,58),n=fxLetters.length;
if(E.text.style.display!=='none'){
if(dyn&&n){var step=300/Math.max(n,6);for(var i=0;i<n;i++){var c=hsl2hex(i*step-hs,100,58);fxLetters[i].style.color=tint(c,0.82);fxLetters[i].style.textShadow=glowShadow(c);}}
else{E.text.style.color=tint(uni,0.82);E.text.style.textShadow=glowShadow(uni);}
}
if(E.logo.style.display!=='none'){E.logo.style.filter='drop-shadow(0 0 3px '+uni+') drop-shadow(0 0 12px '+uni+') drop-shadow(0 0 28px '+rgba(uni,.7)+')';}
if(E.icon.style.display!=='none'){paintIcon(uni);}
paintHalo(uni,dyn?hsl2hex(-hs+140,100,58):uni);
}
function fxTick(now){fxRaf=0;if(!fxOn()){return;}if(now-fxLast>=33){fxLast=now;fxApply((now-fxT0)/1000);}fxRaf=requestAnimationFrame(fxTick);}
function fxStart(){if(fxOn()&&!REDUCE&&!fxRaf){fxRaf=requestAnimationFrame(fxTick);}}
function buildLetters(tx,txt){
tx.textContent='';fxLetters=[];
for(var i=0;i<txt.length;i++){
var ch=txt.charAt(i);
if(ch===NL||ch===' '){tx.appendChild(document.createTextNode(ch));continue;}
var sp=document.createElement('span');sp.textContent=ch;tx.appendChild(sp);fxLetters.push(sp);
}
}
var rsPass=0,CK=1;
function renderSign(){rsPass=0;if(bkType()!=='circle'){CK=1;}renderPass();}
function renderPass(){
var st=E.stage,sw=st.clientWidth,sh=st.clientHeight;
if(!sw){return;}
var c=CFG[S.cat],tw0=Math.max(80,Math.min(sw*0.62,sw*0.95*S.size/c.wall,sw-130)),tw;
if(bkType()==='circle'){tw0=Math.min(tw0,sh*0.7);}
tw=tw0*(bkType()==='circle'?CK:1);
var col=S.color,on=S.on,tx=E.text,lg=E.logo,padX,padY,fs=0;
if(S.cat==='logo'&&S.logoUrl){
tx.style.display='none';lg.style.display='block';lg.style.width=tw+'px';
lg.style.filter=on?'drop-shadow(0 0 3px '+col+') drop-shadow(0 0 12px '+col+') drop-shadow(0 0 28px '+rgba(col,.7)+')':'grayscale(1) brightness(.45)';
E.wrap.style.fontSize='16px';padX=24;padY=18;
}else{
lg.style.display='none';tx.style.display='block';
var raw=S.text,txt=raw.trim()?raw:(S.cat==='logo'?'Your Logo':'Your Text');
var f=fontObj(S.font);
E.meas.style.fontFamily=stack(f);E.meas.style.fontWeight=f[2];E.meas.textContent=txt;
var mw=E.meas.getBoundingClientRect().width||1;
var lines=txt.split(NL).length,maxH=sh*0.34;
fs=100*tw/mw;
if(fs*1.2*lines>maxH){fs=maxH/(1.2*lines);}
E.wrap.style.fontSize=fs+'px';
tx.style.fontFamily=stack(f);tx.style.fontWeight=f[2];tx.style.fontSize='1em';
if(S.fx==='dynamic'&&S.cat!=='logo'){buildLetters(tx,txt);}else{tx.textContent=txt;fxLetters=[];}
tx.style.opacity=raw.trim()?'1':'.85';
if(on&&!S.fx){
tx.style.color=tint(col,0.82);
tx.style.textShadow=glowShadow(col);
}else if(!on){
tx.style.color='#5b5b72';tx.style.textShadow='0 1px 0 rgba(255,255,255,.08),0 -1px 0 rgba(0,0,0,.4)';
for(var q=0;q<fxLetters.length;q++){fxLetters[q].style.color='';fxLetters[q].style.textShadow='';}
}
/* generous side padding: script fonts swash past their measured width */
padX=Math.min(34,Math.max(14,fs*0.36));padY=Math.min(24,Math.max(10,fs*0.2));
}
var padL=padX,padR=padX,ic=E.icon;
if(S.icon&&S.cat!=='logo'&&fs){
var isz=Math.round(Math.max(22,Math.min(fs*1.05,90))),edge=Math.round(padX*0.7),gap=isz+edge+Math.round(Math.max(8,fs*0.2));
ic.style.display='block';ic.style.width=ic.style.height=isz+'px';
if(S.iconPos==='right'){ic.style.right=edge+'px';ic.style.left='auto';padR=gap;}
else{ic.style.left=edge+'px';ic.style.right='auto';padL=gap;}
if(!fxOn()){paintIcon(col);}
}else{ic.style.display='none';}
E.wrap.style.padding=padY+'px '+padR+'px '+padY+'px '+padL+'px';
var cs=g('pxdCut'),cg=g('pxdCutG');cg.textContent='';
var cutOn=(bkType()==='letter'||bkType()==='shape')&&S.cat!=='logo'&&!!fs;
if(cutOn){E.wrap.setAttribute('data-cut','1');}else{E.wrap.removeAttribute('data-cut');}
if(cutOn){
var tw2=E.text.offsetWidth,th2=E.text.offsetHeight,bm=E.meas,sv=bm.textContent,pr=document.createElement('i');
cs.style.left=E.text.offsetLeft+'px';cs.style.top=E.text.offsetTop+'px';cs.style.width=tw2+'px';cs.style.height=th2+'px';
bm.textContent='';pr.style.cssText='display:inline-block;width:0;height:0';bm.appendChild(pr);
var bo=(pr.getBoundingClientRect().bottom-bm.getBoundingClientRect().top)/100*fs;bm.textContent=sv;
txt.split(NL).forEach(function(ln,i){var te=document.createElementNS('http://www.w3.org/2000/svg','text');te.setAttribute('x',tw2/2);te.setAttribute('y',bo+i*1.2*fs);te.setAttribute('text-anchor','middle');te.style.fontFamily=stack(f);te.style.fontWeight=f[2];te.style.fontSize=fs+'px';te.style.whiteSpace='pre';te.textContent=ln;cg.appendChild(te);});
cg.setAttribute('stroke-width',(fs*(bkType()==='shape'?0.6:0.22)).toFixed(1));
}
E.wrap.setAttribute('data-back',bkType());
E.wrap.setAttribute('data-mount',S.mount);
if(!fxOn()){paintHalo(col,col);E.halo.style.background='radial-gradient(closest-side,'+rgba(col,.32)+','+rgba(col,.1)+' 55%,transparent)';}
E.halo.style.opacity=on?'1':'0';
g('pxdWeather').style.display=(QUOTE[S.cat]&&S.place==='Outdoor')?'flex':'none';
var ww=E.wrap.offsetWidth,wh=E.wrap.offsetHeight,kind=bkType(),pn=E.wrap.querySelector('.pxd-panel-bg');
var nL=padX,nR=padX,nT=padY;
if(S.icon&&S.cat!=='logo'&&fs){var eg=Math.round(padX*0.7);if(S.iconPos==='right'){nR=eg;}else{nL=eg;}}
var iN={l:nL,r:nR,t:nT,b:nT},iB={l:0,r:0,t:0,b:0};
if(kind==='letter'){var mg=Math.max(4,Math.round(Math.min(padX,padY)*0.45));iB={l:nL-mg,r:nR-mg,t:nT-mg,b:nT-mg};}
if(kind==='shape'&&cutOn){var ms=fs*0.3,mv=fs*0.1;iB={l:nL-ms,r:nR-ms,t:nT-mv,b:nT-mv};}
if(kind==='circle'&&ww&&wh){var dd=Math.round(Math.sqrt(ww*ww+wh*wh)),ex=(ww-dd)/2,ey=(wh-dd)/2;iB={l:ex,r:ex,t:ey,b:ey};pn.style.width=pn.style.height=dd+'px';}else{pn.style.width=pn.style.height='';}
var bw=ww-iB.l-iB.r,bh=wh-iB.t-iB.b,nw=ww-nL-nR,nh=wh-2*nT;
if(kind==='circle'&&ww&&wh&&rsPass<4){var rr=tw0/bw;if(Math.abs(rr-1)>0.025){CK*=rr;rsPass++;renderPass();return;}}
var wr=E.wrap.querySelectorAll('.pxd-wire');
for(var wi=0;wi<wr.length;wi++){if(kind==='circle'&&dd){var rad=dd/2,sg=wi?1:-1;wr[wi].style.left=(ww/2+sg*0.55*rad)+'px';wr[wi].style.bottom=(wh/2+0.835*rad-13)+'px';}else{wr[wi].style.left='';wr[wi].style.bottom='';}}
var un=bw>0?S.size/bw:0;
HT=un?Math.round(un*bh*10)/10:0;NW=un?Math.round(un*nw*10)/10:0;NH=un?Math.round(un*nh*10)/10:0;
var nv=hasBoard()&&S.view==='neon',vw=nv?iN:iB;
var dw=nv?NW:S.size,dh=nv?NH:HT,dv=g('pxdDimV');dv.style.display=HT?'block':'none';g('pxdDimVLabel').innerHTML=HT?fmt(dh)+' in<br>'+fmt(dh*2.54)+' cm':'';
g('pxdDimLabel').textContent=fmt(dw)+' in / '+Math.round(dw*2.54)+' cm';
var dH=g('pxdDimH').style;dH.left=vw.l+'px';dH.right=vw.r+'px';dH.top='calc(100% - '+iB.b+'px)';
dv.style.top=vw.t+'px';dv.style.bottom=vw.b+'px';dv.style.left='calc(100% - '+iB.r+'px)';
g('pxdViewB').textContent=HT?fmt(S.size)+' × '+fmt(HT)+' in':'';g('pxdViewN').textContent=HT?fmt(NW)+' × '+fmt(NH)+' in':'';
if(fxOn()){fxApply((performance.now()-fxT0)/1000);fxStart();}
}

function renderEst(){
var r=calc(),ul=g('pxdLines');
ul.innerHTML='';
if(r.quote){
g('pxdTotalLabel').textContent='Starting at';g('pxdTotal').textContent='From '+money(P.quote);
g('pxdEstNote').textContent=(S.cat==='business')?'Business signs are priced to size, lighting and installation. Your free mockup includes a written quote.':'Metal and acrylic signs are priced to size, material and finish. Your free mockup includes a written quote.';
g('pxdChip').textContent='Custom quote';
return;
}
r.lines.forEach(function(l){var li=document.createElement('li');var a=document.createElement('span');a.textContent=l[0];var b=document.createElement('span');b.textContent=money(l[1]);li.appendChild(a);li.appendChild(b);ul.appendChild(li);});
g('pxdTotalLabel').textContent='Estimated price';g('pxdTotal').textContent=money(r.total);
g('pxdEstNote').textContent=(r.note?r.note+' ':'')+'Estimate only. Your free mockup confirms the final price.';
g('pxdChip').textContent='Est. '+money(r.total);
}

function sync(){
var r=calc();
g('fCat').value=CFG[S.cat].name;
g('fText').value=S.cat==='logo'?'':S.text.split(NL).join(' / ');
g('fFont').value=S.cat==='logo'?'':S.font;
g('fFontLink').value=S.cat==='logo'?'':'https://fonts.google.com/specimen/'+encodeURIComponent(fontObj(S.font)[1]).replace(/%20/g,'+');
g('fFx').value=S.fx==='dynamic'?'Dynamic Neon (colors move across letters, with remote)':(S.fx==='rgb'?'RGB Color Changing (whole sign changes color, with remote)':'Single color');
g('fColor').value=S.fx?'Set by effect':S.colorName+' ('+S.color+')';
g('fBack').value=BK[bkType()][0];
g('fIcon').value=(S.cat!=='logo'&&S.icon)?S.icon+' ('+S.iconPos+' of text)':'None';
g('fDimmer').value=dimmerOn()?'Yes':'No';
g('fPlug').value=S.plug;
g('fSize').value=HT?S.size+' in wide x about '+HT+' in tall'+(hasBoard()?' (backboard); neon only about '+NW+' x '+NH+' in':''):S.size+' in wide';
g('fMount').value=MOUNTS[S.mount][0];
g('fPlace').value=QUOTE[S.cat]?S.place:'Indoor';
g('fLogo').value=(S.cat==='logo'||QUOTE[S.cat])?S.logoName:'';
var lo=g('pxdLogoOpt');if(lo){lo.textContent=QUOTE[S.cat]?'(optional)':'';}
g('fEst').value=r.quote?'Custom quote':money(r.total)+' (estimate)';
}

function press(sel,attr,val){
var els=root.querySelectorAll(sel);
for(var i=0;i<els.length;i++){els[i].setAttribute('aria-pressed',els[i].getAttribute(attr)===String(val)?'true':'false');}
}
function pageCount(){return Math.ceil(FONTS.length/FONT_PAGE_SIZE);}
function updateFontNav(){
var pages=pageCount();
g('pxdFontPrev').disabled=(fontPage<=0);
g('pxdFontNext').disabled=(fontPage>=pages-1);
var dots=g('pxdFontDots');
dots.innerHTML='';
for(var p=0;p<pages;p++){
var d=document.createElement('i');
d.setAttribute('aria-current',p===fontPage?'true':'false');
(function(pp){d.addEventListener('click',function(){fontPage=pp;renderFontTrack();});})(p);
dots.appendChild(d);
}
}
function renderFontTrack(){
var track=g('pxdFonts');
track.innerHTML='';
var start=fontPage*FONT_PAGE_SIZE,end=Math.min(start+FONT_PAGE_SIZE,FONTS.length);
for(var i=start;i<end;i++){
(function(f){
var b=document.createElement('button');b.type='button';b.className='pxd-opt';b.setAttribute('data-f',f[0]);b.textContent=f[0];
b.style.fontFamily=stack(f);b.style.fontWeight=f[2];
b.addEventListener('click',function(){S.font=f[0];renderAll();ensureFont();});
track.appendChild(b);
})(FONTS[i]);
}
updateFontNav();
updateUI();
}
function updateUI(){
press('#pxdCats .pxd-opt','data-c',S.cat);
g('pxdMountSelect').value=S.mount;
press('#pxdPlace .pxd-opt','data-p',S.place);
press('#pxdScenes .pxd-opt','data-sc',S.photoUrl&&E.stage.getAttribute('data-scene')==='photo'?'photo':S.scene);
var fb=g('pxdFonts').children;
for(var i=0;i<fb.length;i++){fb[i].setAttribute('aria-pressed',fb[i].getAttribute('data-f')===S.font?'true':'false');}
var sw=g('pxdSw').children;
for(var j=0;j<sw.length;j++){sw[j].setAttribute('aria-pressed',(!S.fx&&sw[j].getAttribute('data-h')===S.color&&S.colorName!=='Custom')?'true':'false');}
press('#pxdFx .pxd-opt','data-fx',S.fx);
g('pxdColorCard').className='pxd-card'+(S.fx?' pxd-fxdim':'');
g('pxdRgbNote').textContent=S.fx?'Colors are set by the special effect you chose.':'';
g('pxdFxDynamic').style.display=S.cat==='logo'?'none':'';
g('pxdFxDynP').textContent=P.flow?'+'+money(P.flow):'';
g('pxdFxRgbP').textContent=P.rgb?'+'+money(P.rgb):'';
var bk=S.cat==='logo'?'shape':S.back;
press('#pxdBack .pxd-opt','data-b',bk);
press('#pxdIconPos .pxd-opt','data-ip',S.iconPos);
g('pxdIconPosWrap').hidden=!S.icon;
Array.prototype.forEach.call(g('pxdBack').children,function(b){var k=b.getAttribute('data-b');b.style.display=(S.cat==='logo'&&k!=='shape')?'none':'';var pr=BK[k][1];b.querySelector('.pxd-bbp').textContent=pr?'+'+money(pr):'Included';});
g('pxdIconPrice').textContent=P.icon?'(+'+P.icon+'%)':'';
var ib=g('pxdIcons').children;
for(var q=0;q<ib.length;q++){ib[q].setAttribute('aria-pressed',ib[q].getAttribute('data-i')===S.icon?'true':'false');}
var dOut=(QUOTE[S.cat]&&S.place==='Outdoor');
press('#pxdDimmer .pxd-opt','data-d',dimmerOn()?'yes':'no');
var dbs=g('pxdDimmer').children;for(var w=0;w<dbs.length;w++){dbs[w].disabled=S.fx?true:(dOut&&dbs[w].getAttribute('data-d')==='yes');}
g('pxdDimmerPrice').textContent=S.fx?'Included':(P.dimmer?'+'+money(P.dimmer):'Included');
g('pxdDimNote').textContent=dOut?'Not available for outdoor signs (indoor use only).':(S.fx?'Included free with your special effect.':'Full control of brightness and lighting modes. Indoor use only.');
press('#pxdPlug .pxd-opt','data-pl',S.plug);
var sz=g('pxdSizes').children,cu=g('pxdCustom').value;
var cf=CFG[S.cat],rg=g('pxdRange');rg.min=cf.min;rg.max=cf.max;rg.value=S.size;rg.style.setProperty('--pct',((S.size-cf.min)/(cf.max-cf.min)*100)+'%');
g('pxdSizeVal').textContent=S.size+' in';g('pxdRMin').textContent=cf.min+' in';g('pxdRMax').textContent=cf.max+' in';
if(document.activeElement!==g('pxdCustom')){g('pxdCustom').value=S.size;}
press('#pxdView .pxd-opt','data-v',S.view);
for(var k=0;k<sz.length;k++){sz[k].setAttribute('aria-pressed',(!cu&&Number(sz[k].getAttribute('data-s'))===S.size)?'true':'false');}
g('pxdColorName').textContent=S.fx==='dynamic'?'Dynamic Neon':(S.fx==='rgb'?'RGB Color Changing':(S.colorName==='Custom'?'Custom '+S.color:S.colorName));
g('pxdPick').value=S.color.toLowerCase();
if(document.activeElement!==g('pxdHex')){g('pxdHex').value=S.colorName==='Custom'?S.color:'';}
g('pxdCount').textContent=S.text.length;
g('pxdLight').textContent='Light: '+(S.on?'On':'Off');
g('pxdLight').setAttribute('aria-pressed',S.on?'true':'false');
var cards=root.querySelectorAll('[data-show]');
for(var n=0;n<cards.length;n++){cards[n].hidden=cards[n].getAttribute('data-show').split(',').indexOf(S.cat)<0;}
g('pxdMhangOpt').textContent='Hanging'+(P.hang?' — +'+money(P.hang):' — Included');
g('pxdMtableOpt').textContent='Table stand'+(P.table?' — +'+money(P.table):' — Included');
}
function renderAll(){updateUI();renderSign();renderEst();sync();}
function ensureFont(){
var f=fontObj(S.font);
if(document.fonts&&document.fonts.load){document.fonts.load(f[2]+' 100px '+AP+f[1]+AP,'Abc').then(renderSign,renderSign);}
}

function buildSizes(){
var c=CFG[S.cat],box=g('pxdSizes');
box.innerHTML='';
c.sizes.forEach(function(s){
var b=document.createElement('button');b.type='button';b.className='pxd-opt';b.setAttribute('data-s',s);b.textContent=s+' in';
b.addEventListener('click',function(){S.size=s;g('pxdCustom').value='';renderAll();});
box.appendChild(b);
});
g('pxdCustom').min=c.min;g('pxdCustom').max=c.max;g('pxdCustom').value='';
g('pxdCustomHint').textContent='Custom width: '+c.min+' to '+c.max+' in.';
}
function setCat(c){
S.cat=c;S.size=CFG[c].def;if(c==='logo'&&S.fx==='dynamic'){S.fx='rgb';}
S.place=(c==='business')?'Outdoor':'Indoor';S.on=!(c==='metal'||c==='acrylic');
var fine=g('pxdFine');if(fine){fine.textContent=(c==='metal'||c==='acrylic')?'This preview shows layout only. Your free mockup shows the real material, finish and size, and your quote confirms the price.':'This preview is a guide. Your free mockup is the final design, and your quote or checkout confirms the price.';}
if(!S.sceneUser&&!(S.photoUrl&&E.stage.getAttribute('data-scene')==='photo')){S.scene=(c==='business')?'brick':'charcoal';E.stage.setAttribute('data-scene',S.scene);}
buildSizes();renderAll();ensureFont();
}
function setScene(s){
S.scene=s;S.sceneUser=true;E.stage.setAttribute('data-scene',s);renderAll();
}
function setColor(hex,name){S.color=hex.toUpperCase();S.colorName=name;renderAll();}

/* build controls */
COLORS.forEach(function(c){
var b=document.createElement('button');b.type='button';b.setAttribute('data-h',c[1].toUpperCase());b.title=c[0];b.setAttribute('aria-label',c[0]);
b.style.background=c[1];
b.addEventListener('click',function(){setColor(c[1],c[0]);});
g('pxdSw').appendChild(b);
});

Array.prototype.forEach.call(g('pxdFx').children,function(b){b.addEventListener('click',function(){S.fx=b.getAttribute('data-fx');renderAll();});});
Array.prototype.forEach.call(g('pxdIconPos').children,function(b){b.addEventListener('click',function(){S.iconPos=b.getAttribute('data-ip');renderAll();});});
function svgIcon(d){return '<svg viewBox="0 0 24 24" aria-hidden="true">'+d+'</svg>';}
(function(){
var box=g('pxdIcons');
var none=document.createElement('button');none.type='button';none.className='pxd-opt';none.setAttribute('data-i','');none.textContent='None';
none.addEventListener('click',function(){S.icon='';E.icon.innerHTML='';renderAll();});
box.appendChild(none);
ICONS.forEach(function(ic){
var b=document.createElement('button');b.type='button';b.className='pxd-opt';b.setAttribute('data-i',ic[0]);b.title=ic[0];b.setAttribute('aria-label',ic[0]);b.innerHTML=svgIcon(ic[1]);
b.addEventListener('click',function(){S.icon=ic[0];E.icon.innerHTML=svgIcon(ic[1]);renderAll();});
box.appendChild(b);
});
})();
Array.prototype.forEach.call(g('pxdBack').children,function(b){b.addEventListener('click',function(){S.back=b.getAttribute('data-b');renderAll();});});
Array.prototype.forEach.call(g('pxdDimmer').children,function(b){b.addEventListener('click',function(){S.dimmer=b.getAttribute('data-d')==='yes';renderAll();});});
Array.prototype.forEach.call(g('pxdPlug').children,function(b){b.addEventListener('click',function(){S.plug=b.getAttribute('data-pl');renderAll();});});

/* events */
var cb=g('pxdCats').children;
for(var i=0;i<cb.length;i++){(function(b){b.addEventListener('click',function(){setCat(b.getAttribute('data-c'));});})(cb[i]);}
g('pxdMountSelect').addEventListener('change',function(){S.mount=this.value;renderAll();});
var pb=g('pxdPlace').children;
for(var k=0;k<pb.length;k++){(function(b){b.addEventListener('click',function(){S.place=b.getAttribute('data-p');renderAll();});})(pb[k]);}
var sb=g('pxdScenes').children;
for(var m=0;m<sb.length;m++){(function(b){b.addEventListener('click',function(){setScene(b.getAttribute('data-sc'));});})(sb[m]);}
g('pxdLight').addEventListener('click',function(){S.on=!S.on;renderAll();});
g('pxdFontPrev').addEventListener('click',function(){if(fontPage>0){fontPage--;renderFontTrack();}});
g('pxdFontNext').addEventListener('click',function(){if(fontPage<pageCount()-1){fontPage++;renderFontTrack();}});
g('pxdInput').addEventListener('input',function(){
var v=this.value,parts=v.split(NL);
if(parts.length>3){v=parts.slice(0,3).join(NL);this.value=v;}
S.text=v;renderAll();
});
g('pxdPick').addEventListener('input',function(){setColor(this.value,'Custom');});
g('pxdHex').addEventListener('input',function(){
var v=this.value.trim();
if(v.charAt(0)!=='#'){v='#'+v;}
if(hexOk(v)){setColor(v,'Custom');}
});
g('pxdCustom').addEventListener('input',function(){
var c=CFG[S.cat],v=parseInt(this.value,10);
if(!isNaN(v)&&v>=c.min&&v<=c.max){S.size=v;renderAll();}
});
g('pxdCustom').addEventListener('change',function(){
var c=CFG[S.cat],v=parseInt(this.value,10);
if(isNaN(v)){this.value='';renderAll();return;}
v=Math.max(c.min,Math.min(c.max,v));this.value=v;S.size=v;renderAll();
});
g('pxdRange').addEventListener('input',function(){var v=parseInt(this.value,10);if(!isNaN(v)){S.size=v;renderAll();}});
Array.prototype.forEach.call(g('pxdView').children,function(b){b.addEventListener('click',function(){S.view=b.getAttribute('data-v');renderAll();});});
g('pxdLogoFile').addEventListener('change',function(){
var f=this.files&&this.files[0];
if(!f){return;}
if(S.logoUrl){URL.revokeObjectURL(S.logoUrl);}
S.logoUrl=URL.createObjectURL(f);S.logoName=f.name;E.logo.src=S.logoUrl;renderAll();
});
g('pxdPhotoFile').addEventListener('change',function(){
var f=this.files&&this.files[0];
if(!f){return;}
if(S.photoUrl){URL.revokeObjectURL(S.photoUrl);}
S.photoUrl=URL.createObjectURL(f);E.photo.src=S.photoUrl;E.stage.setAttribute('data-scene','photo');S.sceneUser=true;renderAll();
});
g('pxdForm').addEventListener('submit',function(e){
var msg='';
if(S.cat==='logo'){if(!S.logoName){msg='Please choose your logo file first, so we know what to make.';}}
else if(!S.text.trim()&&!(QUOTE[S.cat]&&S.logoName)){msg=QUOTE[S.cat]?'Please type your text or choose your logo file first.':'Please type your text first.';}
if(msg){
e.preventDefault();
var er=g('pxdErr');er.textContent=msg;er.style.display='block';
er.scrollIntoView({block:'center',behavior:'smooth'});
}
});
window.addEventListener('resize',renderSign);
if(document.fonts&&document.fonts.ready){document.fonts.ready.then(renderSign);}

buildSizes();
renderFontTrack();
renderAll();
ensureFont();
try{var qt=new URLSearchParams(window.location.search).get('type');if(qt&&CFG[qt]&&qt!=='neon'){setCat(qt);}}catch(e){}
})();